// extracted by mini-css-extract-plugin
export default {"panelOuter":"panel-outer--iMAxF2jGh0NhNgAQO97g","panelInner":"panel-inner--q_oFzi7O0XxGg7UcDvlG","panelHeader":"panel-header--qGRHCKL5idBjf1S_519b"};